<div class="wrapper flex lg:hidden" (click)="isOpen = true">
  Get Help
  <ng-icon name="featherHelpCircle" size="18"></ng-icon>
</div>

<div
  class="wrapper hidden lg:flex"
  tpPlacement="bottom"
  tp="Get help with this page"
  (click)="isOpen = true"
>
  Get Help
  <ng-icon name="featherHelpCircle" size="18"></ng-icon>
</div>

<!-- My Deals -->
<app-shared-modal
  name="Help - My Deals"
  [open]="isOpen && content === 'my-deals'"
  (modalClose)="isOpen = false"
>
  <div class="hel-content">
    <p>Help content is not available for this page yet.</p>
    <p>
      If you have any questions, please contact us at
      <a href="mailto:help@rebuilt.com?subject=Support Rebuilt Marketplace">{{
        'help@rebuilt.com'
      }}</a
      >.
    </p>
  </div>
</app-shared-modal>

<!-- Upload Buyers -->
<app-shared-modal
  name="Buyer List Upload Checklist"
  [open]="isOpen && content === 'upload-buyers'"
  (modalClose)="isOpen = false"
>
  <div class="help-content">
    <ol>
      <li>
        <span class="font-semibold">Upload Format:</span> Use a .csv file.
      </li>
      <li>
        <span class="font-semibold">Required Columns:</span>
        <ul>
          <li>Either: <span class="font-semibold">Name, Email, Phone</span></li>
          <li>
            Or:
            <span class="font-semibold"
              >First Name, Last Name, Email, Phone</span
            >
          </li>
        </ul>
      </li>
      <li>
        <span class="font-semibold">Column Headers:</span>
        <ul>
          <li>Headers like “Email” or “Phone” are auto-mapped.</li>
        </ul>
      </li>
      <li>
        <span class="font-semibold">Mapping Step:</span>
        <ul>
          <li>You’ll review and confirm column mapping.</li>
        </ul>
      </li>
      <li>
        <span class="font-semibold">Preview:</span>
        <ul>
          <li>Check the preview to ensure everything looks correct.</li>
        </ul>
      </li>
      <li>
        <span class="font-semibold">Row Limit:</span>
        <ul>
          <li>
            File must have
            <span class="font-semibold"
              >{{ maxBuyersListRows }} rows or fewer</span
            >.
          </li>
        </ul>
      </li>
    </ol>
  </div>
</app-shared-modal>
